/**
 * formats phone number to international format
 * @param {*} phoneNumberString
 */
export const formatPhoneNumber = (phoneNumberString) => {
    let target = null;
    const input = ('' + phoneNumberString).replace(/\D/g, ''); // First ten digits of input only
    let areaCode;
    let middle;
    let last;
    try {
        areaCode = input.substring(0, 3);
        middle = input.substring(3, 6);
        last = input.substring(6, input.length);
    } catch (error) {}
    if (input.length > 6) {
        target = `(${areaCode}) ${middle} - ${last}`;
    } else if (input.length > 3) {
        target = `(${areaCode}) ${middle}`;
    } else if (input.length > 0) {
        target = `(${areaCode}`;
    } else {
        target = phoneNumberString;
    }
    return target;
};
